import { ActivityCode, Audit, EntityType } from '@eppendorf/vnls-audit-event-client';

import { getIdTokenPayload } from '$shared/auth/auth-service';

interface AuditEventOptions {
  isCurrentUserAffected?: boolean;
}

export const createAuditEvent = async (
  activityCode: ActivityCode,
  options: AuditEventOptions = { isCurrentUserAffected: false },
) => {
  const { isCurrentUserAffected } = options;
  const currentUser = await getIdTokenPayload();

  const auditEvent = Audit.triggered(activityCode)
    .byUser(currentUser?.email)
    .withTenantId(currentUser?.tenantId);

  if (isCurrentUserAffected) {
    auditEvent.withAffected({
      type: EntityType.User,
      id: currentUser?.email,
    });
  }

  return auditEvent;
};
